export const INPUT_VALUE_REGEX = /^[0-9.-]*$/;

export const VERTICAL_ORIENTATION = 'vertical';
export const HORIZONTAL_ORIENTATION = 'horizontal';
export const HEAD_PLACEMENT = 'head';

export const INPUT_WIDTH = 47;
export const INPUT_HEIGHT = 20;
export const MIN_ARROW_GAP = 12;
export const INNER_GAP = 24;

export const VERTICAL_MIN_GAP = 90;
export const HORIZONTAL_MIN_GAP = 48;

export const DIMENSION = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const HOVER_AREA_WIDTH_BY_DIMENSION = {
  [DIMENSION.small]: 40,
  [DIMENSION.medium]: 64,
  [DIMENSION.large]: 120,
};

export const HOVER_AREA_HEIGHT = 40;
